/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TeamsInputs */

const th_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีม`)
};

const en_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ja_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const zh_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队`)
};

const es_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipos`)
};

const pt_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Times`)
};

const id_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

const fr_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipes`)
};

const tl_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga team`)
};

const vi_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội`)
};

const ko_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀`)
};

const de_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ru_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команды`)
};

const tr_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlar`)
};

const it_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadre`)
};

const pl_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyny`)
};

const uk_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команди`)
};

const hi_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीमें`)
};

const ar_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفرق`)
};

const ms_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan`)
};

const bn_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const zh_hk2_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const ur_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیمیں`)
};

const fa_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم‌ها`)
};

const sw_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu`)
};

const nl_teams = /** @type {(inputs: TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const teams = /** @type {((inputs?: TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_teams(inputs)
	if (locale === "ja") return ja_teams(inputs)
	if (locale === "zh") return zh_teams(inputs)
	if (locale === "es") return es_teams(inputs)
	if (locale === "pt") return pt_teams(inputs)
	if (locale === "id") return id_teams(inputs)
	if (locale === "fr") return fr_teams(inputs)
	if (locale === "tl") return tl_teams(inputs)
	if (locale === "vi") return vi_teams(inputs)
	if (locale === "ko") return ko_teams(inputs)
	if (locale === "de") return de_teams(inputs)
	if (locale === "ru") return ru_teams(inputs)
	if (locale === "tr") return tr_teams(inputs)
	if (locale === "it") return it_teams(inputs)
	if (locale === "pl") return pl_teams(inputs)
	if (locale === "uk") return uk_teams(inputs)
	if (locale === "hi") return hi_teams(inputs)
	if (locale === "ar") return ar_teams(inputs)
	if (locale === "ms") return ms_teams(inputs)
	if (locale === "bn") return bn_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_teams(inputs)
	if (locale === "ur") return ur_teams(inputs)
	if (locale === "fa") return fa_teams(inputs)
	if (locale === "sw") return sw_teams(inputs)
	if (locale === "nl") return nl_teams(inputs)
	return en_teams(inputs)
});